import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable()
export class UiContextService {
  public isTouchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  public isWebpSupported: boolean = false;

  constructor(@Inject(PLATFORM_ID) private _platformId: Object) {
    this.isWebpSupported = this._isWebpSupported();
  }

  getWindowWidth(): number {
    if (isPlatformBrowser(this._platformId)) {
      return window.innerWidth;
    }

    return 1600;
  }

  isXs(): boolean {
    return this.getWindowWidth() < 575;
  }

  isSm(): boolean {
    return this.getWindowWidth() < 768;
  }

  isMd(): boolean {
    return !this.isSm() && this.getWindowWidth() <= 991;
  }

  isLg(): boolean {
    return !this.isSm() && !this.isMd() && this.getWindowWidth() <= 1199;
  }

  isXl(): boolean {
    return this.getWindowWidth() >= 1200;
  }

  isMobile(): boolean {
    return this.isTouchDevice || this.getWindowWidth() < 768;
  }

  private _isWebpSupported(): boolean {
    if (isPlatformServer(this._platformId)) {
      return true;
    }

    const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    const isIE = /MSIE/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /MSIE/i.test(navigator.userAgent);
    const isEdge = /Edge\/\d./i.test(navigator.userAgent);
    const isFirefox = /firefox/i.test(navigator.userAgent);
    const isUIWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);

    return !isSafari && !isIE && !isFirefox && !isEdge && !isUIWebView;
  }
}
